module.filter('propsFilter', function() {
	return function(items, props) {
		var out = [];

		if (angular.isArray(items)) {
			items.forEach(function(item) {
				var itemMatches = false;

				var keys = Object.keys(props);
				for (var i = 0; i < keys.length; i++) {
					var prop = keys[i];
					var text = props[prop].toLowerCase();
					var spt = prop.split(".");
					var valu = "";
					if (spt.length === 2) {
						valu = item[spt[0]][spt[1]];
					} else if (spt.length === 3) {
						valu = item[spt[0]][spt[1]][spt[2]];
					} else {
						valu = item[prop];
					}
					if (valu.toString().toLowerCase().indexOf(text) !== -1) {
						itemMatches = true;
						break;
					}
				}

				if (itemMatches) {
					out.push(item);
				}
			});
		} else {
			// Let the output be the input untouched
			out = items;
		}

		return out;
	};
});

module.filter('momentDate', [ 'dateUtilService', function(dateUtil) {
	return function(input, option) {
		var mDate = input;
		if (!(moment.isMoment(input))) {
			mDate = moment(input);
		}
		if (angular.isUndefined(option) || option == 'calendar')
			return mDate.calendar();
		if (option == 'fulldate')
			return dateUtil.format2FullDate(mDate);
		if (option == 'fulldatetime')
			return dateUtil.format2FullDateTime(mDate);
		if (option == 'fromNow')
			return mDate.fromNow(true);
		return input.calendar();
	}
} ]);

module.filter('activeInactive', function() {
	return function(input) {
		return input ? 'Activo' : 'Inactivo';
	}
});

module.filter('samplingMethodByProduct', function() {
	return function(input, option) {
		var out = [];
		
		if(angular.isUndefined(input))
			return input;
		
		var getProduct = function(p) {
			return p.id == this;
		};
		var getSamplingMethod = function(sm) {
			if (sm.products.some(getProduct, this))
				out.push(sm);
		};

		if (angular.isArray(input)) {
			input.forEach(getSamplingMethod, option);
		} else {
			if (input.products.some(getProduct, option))
				out = input;
		}
		
		return out;
	}
});

module.filter('crudType', function() {
	return function(input) {
		if (input == 'search')
			return 'Busqueda de';
		if (input == 'create')
			return 'Crear';
		if (input == 'update')
			return 'Actualizar';
		if (input == 'copy')
			return 'Copiar';
		if (input == 'clone')
			return 'Clonar';
		if (input == 'add')
			return 'Adicionar';
		return '';
	}
});

module.filter('constantName', function() {
	return function(input, constant) {
		if (input != null && input != '')
			return getConstantNameById(eval(constant), input);
		return '';
	}
});

module.filter('constantId', function() {
	return function(input, constant) {
		if (input != null && input != '')
			return getConstantId(eval(constant), input);
		return '';
	}
});

module.filter('inArray', function() {
	return function(input, array) {
		return array.indexOf(input) >= 0;
	};
});

module.filter('defaultNumber', function() {
	return function(input) {
		if (angular.isNumber(input)) {
			return input;
		} else {
			return 0;
		}
	}
});

module.filter('isEmpty', function() {
	var bar;
	return function(obj) {
		if (angular.isUndefined(obj)) {
			return true;
		}
		for (bar in obj) {
			if (obj.hasOwnProperty(bar)) {
				return false;
			}
		}
		return true;
	};
})

module.filter('defaultString', function() {
	return function(input) {
		if (angular.isString(input)) {
			return input;
		} else {
			return '-';
		}
	}
});

module.filter('temperature', function() {
	return function(input) {
		if (angular.isUndefined(input) || input == null) {
			return 'N/A';
		} else {
			return input + ' <small><em>&#176;C</em></small>';
		}
	}
});

module.filter('orp', function() {
	return function(input) {
		if (angular.isUndefined(input) || input == null) {
			return 'N/A';
		} else {
			return input + ' <small><em>mV</em></small>';
		}
	}
});

module.filter('chlorine', function() {
	return function(input) {
		if (angular.isUndefined(input) || input == null) {
			return 'N/A';
		} else {
			return input + ' <small><em>mg/L</em></small>';
		}
	}
});


module.filter('defaultUndefined', function() {
	return function(input, text) {
		if (angular.isUndefined(input) || input == null) {
			if (text)
				return text;
			return 'N/A';
		} else {
			return input;
		}
	}
});